module.exports = __webpack_public_path__ + "static/media/headerLogo.211de04c.png";